import React, { useState, useCallback, lazy, Suspense } from 'react';
import useInactivityMonitor from './hooks/useInactivityMonitor';
import Header from './Header';
import StepOne from './StepOne';

import './styles.css';

// Importations dynamiques (Lazy Loading)
const StepTwo = lazy(() => import('./StepTwo'));
const StepThree = lazy(() => import('./StepThree'));
const StepFour = lazy(() => import('./StepFour'));
const StepFive = lazy(() => import('./StepFive'));
const StepSix = lazy(() => import('./StepSix'));
const StepSeven = lazy(() => import('./StepSeven'));
const StepEight = lazy(() => import('./StepEight'));

const INITIAL_FORM_DATA = {
    truckingCompany: '',
    truckNumber: '',
    licencePlate: '',
    bookNumber: '',
    bookData: {},
    bookedEquipment: [],
    isBundle: false,
    terminal: {},
    transport: {},
    errorMessage: '',
    attachGenset: false,
    interchangeNumber: [],
    user: '',
    line: {},
    genset: {},
    qtyToPickUp: '',
};

const LoadingSpinner = () => {
    return (
        <div className="text-center kform"> 
            <i className="fa fa-spinner fa-spin d-block fs-2 p-2"></i>
        </div>
    );
};

const Elift = () => {
    //const { t, i18n, ready } = useTranslation();

    const [formData, setFormData] = useState(INITIAL_FORM_DATA);
    const [stepHistory, setStepHistory] = useState([1]);  // Tableau pour stocker les étapes visitées, commençant par l'étape 1
    const currentStep = stepHistory[stepHistory.length - 1]; // L'étape courrante est toujours la dernière du tableau d'historique  

    const updateFormData = (data) => {
        setFormData(prevData => ({ ...prevData, ...data }));
    };

    const cardStyle = {
        boxShadow: '0px 0px 30px 0px rgba(0, 0, 0, 0.3)',
        maxWidth: '600px'
    };

    /**
     * Gère la navigation vers une nouvelle étape (forward, >= 1) ou le retour en arrière (-1).
     * @param {number} destination - Le numéro de l'étape cible ou -1 pour revenir en arrière.
     */
    const handleNavigation = useCallback((destination) => {

        setStepHistory(prevHistory => {

            // --- CAS 1 : Gérer la navigation vers une étape spécifique (FORWARD) ---
            // On vérifie si la destination est un step valide (entre 1 et 8)
            if (destination >= 1 && destination <= 8) {
                // Ajoute la nouvelle étape à l'historique
                return [...prevHistory, destination];
            }

            // --- CAS 2 : Gérer le retour en arrière (BACKWARD) ---
            else if (destination === -1) {
                if (prevHistory.length > 1) {
                    // Supprime la dernière étape de l'historique
                    const newHistory = prevHistory.slice(0, prevHistory.length - 1); // Créer un nouvel historique sans la dernière étape (l'étape actuelle)
                    return newHistory;
                    //return prevHistory.slice(0, prevHistory.length - 1);
                }
                return prevHistory; // Reste sur la première étape si on ne peut pas revenir plus loin
            }

            // --- CAS 3 : Gérer les entrées invalides ---
            else {
                console.error(`Tentative de navigation vers une destination invalide : ${destination}`);
                return prevHistory; // Ne change pas l'historique
            }
        });

    }, []); // Dépendances vides

    const handleSubmit = () => {

        console.log("Form submitted successfully:", formData);
        //alert("Form submitted successfully!");
        
        setFormData(INITIAL_FORM_DATA); //Reset form 
        setStepHistory([1]);  // Revenir à l'étape 1 et effacer l'historique
    };

    const renderStep = () => {
        switch (currentStep) {
            //case 1:
            //    return (
            //        <StepOne formData={formData} updateFormData={updateFormData} navigate={handleNavigation} />
            //    );

            case 2:
                return (
                    <StepTwo
                        formData={formData} updateFormData={updateFormData} navigate={handleNavigation} />
                );

            case 3:
                return (
                    <StepThree formData={formData} updateFormData={updateFormData} navigate={handleNavigation} />
                );

            case 4:
                return (
                    <StepFour formData={formData} updateFormData={updateFormData} navigate={handleNavigation} />
                );

            case 5:
                return (
                    <StepFive formData={formData} updateFormData={updateFormData} navigate={handleNavigation} />
                );

            case 6:
                return (
                    <StepSix formData={formData} updateFormData={updateFormData} navigate={handleNavigation} />
                );

            case 7:
                return (
                    <StepSeven formData={formData} navigate={handleNavigation} handleSubmit={handleSubmit} />
                );

            case 8:
                return (
                    <StepEight formData={formData} updateFormData={updateFormData} navigate={handleNavigation} />
                );

            default:
                return null;
        }
    };

    // Fonction qui sera appelée après 30 secondes d'inactivité
    const handleInactivityTimeout = useCallback(() => {
        alert("inactivity detected !");
        setStepHistory([1]); // Réinitialise l'étape du formulaire 
        setFormData(INITIAL_FORM_DATA);
    }, []);

    // Active le moniteur d'inactivité seulement sur cette page
    useInactivityMonitor(handleInactivityTimeout);

    return (
        <div className="d-flex flex-column min-vh-100">
            <div className="sticky-top">
                <Header />
            </div>
            <div className="content-scroll-wrapper flex-grow-1 d-flex justify-content-center align-items-center">
                <div className="bg-secondary p-2 rounded-2 w-100 kcard" style={cardStyle}>
                    {currentStep === 1 ? (
                        <StepOne formData={formData} updateFormData={updateFormData} navigate={handleNavigation} />
                    ) : (
                        <Suspense fallback={<LoadingSpinner />}>
                            {renderStep()}
                        </Suspense>
                    )}
                </div>                
            </div>
            <div className="d-flex justify-content-end align-items-center">
                <p className="fs-6 px-2 mb-2">© {new Date().getFullYear()} Hunt Refrigeration (Canada) Inc.</p>
            </div>
        </div>
    );
};

export default Elift